<template>
  <div id="numberManage">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'numberManage'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/exhibition/prediction/number/Manage.vue